import { render, staticRenderFns } from "./search-forms-order-confirmation.vue?vue&type=template&id=6b56b30b&scoped=true&"
import script from "./search-forms-order-confirmation.vue?vue&type=script&lang=js&"
export * from "./search-forms-order-confirmation.vue?vue&type=script&lang=js&"
import style0 from "./search-forms-order-confirmation.vue?vue&type=style&index=0&id=6b56b30b&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6b56b30b",
  null
  
)

export default component.exports